import { render } from "./ArticleElement.vue?vue&type=template&id=5a906dda"
import script from "./ArticleElement.vue?vue&type=script&lang=js"
export * from "./ArticleElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__